interface Params {
  h: string | number;
  w: string | number;
}

interface Result {
  imc: number;
  classification: string;
}

export function imcCalc({ h, w }: Params): Result {
  const height = +h || 0;
  const weight = +w || 0;

  const imc = Number(Math.floor(weight / height ** 2).toFixed(2));

  const classification = getClassification(imc);

  return {
    imc,
    classification,
  };
}

function getClassification(imc: number): string {
  switch (true) {
    case imc < 18.5:
      return 'BAIXO PESO';

    case imc <= 24.9:
      return 'PESO NORMAL';

    case imc <= 29.9:
      return 'ACIMA DO PESO';

    case imc <= 34.9:
      return 'OBESIDADE 01';

    case imc <= 39.9:
      return 'OBESIDADE 02';

    case imc > 40.0:
      return 'OBESIDADE 03';

    default:
      return '';
  }
}
